<template>
  <div class="content-box">
    <Title />
    <div>
      <div class="title-right">
        <a href="https://www.100ec.cn/zt/wssybzl/" target="_blank">
          <img src="https://www.100ec.cn/zt/wssybzl/img/960.gif" />
        </a>
      </div>
    </div>
    <el-menu
      :default-active="activeIndex"
      class="el-menu-demo"
      mode="horizontal"
    >
      <el-menu-item
        :index="String(index + 1)"
        v-for="(i, index) of dataNav"
        :key="index"
        @click="handleSelect(index)"
      >
        {{ i.label }}</el-menu-item
      >
    </el-menu>

    <div class="mobile-select">
      <el-select v-model="name" @change="handleSelect2">
        <el-option
          v-for="item in dataNav"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>

    <Textlist />
  </div>
</template>

<script>
export default {
  name: "broadCast",
  data() {
    return {
      activeIndex: "1",
      name: "滚动播报",
      dataNav: [
        {
          value: "供应链",
          label: "滚动播报",
        },
        {
          value: "供应链 金融",
          label: "供应链金融",
        },
        {
          value: "供应链 管理",
          label: "供应链管理",
        },
        {
          value: "供应链 服务",
          label: "供应链服务",
        },
        {
          value: "供应链 方案",
          label: "供应链方案",
        },
        {
          value: "供应链 创新",
          label: "供应链创新",
        },
        {
          value: "供应链 运营",
          label: "供应链运营",
        },
        {
          value: "供应链 论坛",
          label: "论坛",
        },
        {
          value: "供应链 峰会",
          label: "峰会",
        },
        {
          value: "供应链 大会",
          label: "大会",
        },
        {
          value: "供应链 研讨会",
          label: "研讨会",
        },
        {
          value: "供应链 案例",
          label: "案例",
        },
        {
          value: "供应链 研报",
          label: "研报",
        },
        {
          value: "供应链 报告",
          label: "报告",
        },
        {
          value: "供应链 盘点",
          label: "盘点",
        },
        {
          value: "意见 供应链",
          label: "意见",
        },
        {
          value: "浅析 供应链",
          label: "浅析",
        },
        {
          value: "分析 供应链",
          label: "分析",
        },
        {
          value: "PPT 供应链",
          label: "PPT",
        },
        {
          value: "物流 供应链",
          label: "物流",
        },
        {
          value: "零售 供应链",
          label: "零售",
        },
        {
          value: "跨境 供应链",
          label: "跨境",
        },
        {
          value: "服装 供应链",
          label: "服装",
        },
        {
          value: "餐饮 供应链",
          label: "餐饮",
        },
        {
          value: "生鲜 供应链",
          label: "生鲜",
        },
        {
          value: "医药 供应链",
          label: "医药",
        },
        {
          value: "农产品 供应链",
          label: "农产品",
        },
        {
          value: "钢铁 供应链",
          label: "钢铁",
        },
        {
          value: "汽车 供应链",
          label: "汽车",
        },
        {
          value: "快消品 供应链",
          label: "快消品",
        },
        {
          value: "家居 供应链",
          label: "家居",
        },
        {
          value: "阿里 供应链",
          label: "阿里",
        },
        {
          value: "亚马逊 供应链",
          label: "亚马逊",
        },
        {
          value: "京东 供应链",
          label: "京东",
        },
        {
          value: "拼多多 供应链",
          label: "拼多多",
        },
        {
          value: "生意宝 供应链",
          label: "生意宝",
        },
        {
          value: "小米 供应链",
          label: "小米",
        },
        {
          value: "苏宁 供应链",
          label: "苏宁",
        },
        {
          value: "菜鸟 供应链",
          label: "菜鸟",
        },
        {
          value: "百世 供应链",
          label: "百世",
        },
        {
          value: "顺丰 供应链",
          label: "顺丰",
        },
        {
          value: "怡亚通",
          label: "怡亚通",
        },
      ],
      params: {
        json: 0,
        filter: [
          "分析",
          "（PPT）",
          "（全文）",
          "实战：",
          "张周平",
          "曹磊",
          "莫岱青",
          "蒙慧欣",
          "李鹏博",
          "朱秋城",
          "林智勇",
          "吕友臣",
          "刘俊斌",
        ],
      },
    };
  },
  created() {
    this.$store.commit("textparams", this.params);
    this.$store.commit("changeKeys", this.dataNav[0].value);
    this.$store.dispatch("getText");
  },
  methods: {
    handleSelect(index) {
      this.$store.commit("changeKeys", this.dataNav[index].value);
      this.$store.dispatch("getText");
    },
    handleSelect2(value) {
      this.$store.commit("changeKeys", value);
      this.$store.dispatch("getText");
    },
  },
};
</script>
<style scoped>
#app .content-left .el-menu--horizontal > .el-menu-item {
  height: auto;
  line-height: 40px;
  padding: 0 16px;
}
.title {
  position: relative;
}
.title-right {
  position: absolute;
  left: 195px;
  top: 65px;
}
.title-right img {
  width: 580px;
  height: 70px;
}
@media (max-width: 1100px) {
  .title-right {
    position: static;
    margin: 10px 0;
  }
  .title-right img {
    width: 100%;
    height: 50px;
  }
}
</style>